import React from 'react'
import { getDangerousHtml } from '../../helpers/components';

const ProductDescription = ({ children }) => (
  <div className="txt-bdy-2 clearboth ProductDescription" dangerouslySetInnerHTML={getDangerousHtml(children)} />
);

export default ProductDescription;



// WEBPACK FOOTER //
// ./src/components/ProductDescription/index.js